export var Role;

(function (Role) {
  Role["ADMIN"] = "ADMIN";
  Role["DEALER"] = "DEALER";
  Role["ROOT"] = "ROOT";
})(Role || (Role = {}));

export var UsersOrderBy = {
  phone: 'PHONE',
  email: 'EMAIL',
  username: 'USERNAME',
  createdAt: 'CREATED_AT',
  updatedAt: 'UPDATED_AT'
};